import withStyles from "react-jss"
import colors from "../../data/colors"
import { SECTION_MAX_WIDTH, MAX_WIDTH } from "../../data/globalStyles"
import { TextSection } from ".."

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    boxSizing: "border-box",
    width: "100%",
    maxWidth: SECTION_MAX_WIDTH,
    margin: "0 auto",
  },
  textContainer: {
    boxSizing: "border-box",
    width: "100%",
    zIndex: 2,
  },
  sticky: {
    boxSizing: "border-box",
    position: "sticky",
    bottom: 0,
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // marginBottom: "-60vh",
    [`@media only screen and (max-width: ${MAX_WIDTH})`]: {
      //marginBottom: "-32vh",
    },
  },
  title: {
    color: colors.white,
    fontSize: "48px",
    fontFamily: "WiredMono",
    textTransform: "uppercase",
    textAlign: "center",
    padding: "0 16px",
    lineHeight: "58px",
    maxWidth: MAX_WIDTH,
    // margin: "64px 0",
    background: "black",
    transition: `opacity 0.3s ease-in`,
    "@media only screen and (max-width: 440px)": {
      fontSize: "40px",
      lineHeight: "1.2em"
    },
  },
  invisibleTrigger: {
    width: "100%",
    height: "40px",
    background: "transparent",
    pointerEvents: "none",
    margin: "100vh 0 -100vh 0",
  },
  invisibleTickerTrigger: {
    width: "100%",
    height: "40px",
    background: "transparent",
    pointerEvents: "none",
    margin: "100vh 0 -100vh 0",
    color: "#ffffff",
  },
}

const StickySectionDivider = ({ classes, title, textSectionData }) => {
  return (
    <>
      <section className={classes.container}>
        <div className={classes.textContainer}>
          <div
            id="stickyTicker-trigger"
            className={classes.invisibleTickerTrigger}
            aria-hidden="true"
          />
          <TextSection data={textSectionData} />
          <div
            id="stickySectionDivider-trigger"
            className={classes.invisibleTrigger}
            aria-hidden="true"
          />
        </div>
        <div className={classes.sticky}>
          <h2 className={classes.title}>{title}</h2>
        </div>
      </section>
    </>
  )
}

export default withStyles(styles)(StickySectionDivider)
